import React from 'react';

const Star = ({ width = 25, height = 25, fill = "currentColor" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 38 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.1958 7.70821C16.7632 2.88416 17.5469 0.472135 19 0.472135C20.4531 0.472135 21.2368 2.88416 22.8042 7.7082L23.4903 9.81966C23.9235 11.153 24.1401 11.8197 24.6659 12.2016C25.1916 12.5836 25.8926 12.5836 27.2945 12.5836H29.5146C34.5869 12.5836 37.1231 12.5836 37.5721 13.9656C38.0211 15.3475 35.9693 16.8382 31.8658 19.8197L30.0697 21.1246C28.9355 21.9487 28.3683 22.3607 28.1675 22.9787C27.9667 23.5967 28.1833 24.2634 28.6166 25.5967L29.3026 27.7082C30.87 32.5322 31.6538 34.9443 30.4782 35.7984C29.3026 36.6525 27.2508 35.1618 23.1472 32.1803L21.3511 30.8754C20.2169 30.0513 19.6498 29.6393 19 29.6393C18.3502 29.6393 17.7831 30.0513 16.6489 30.8754L14.8528 32.1803C10.7492 35.1618 8.69738 36.6525 7.52181 35.7984C6.34624 34.9443 7.12995 32.5322 8.69738 27.7082L9.38343 25.5967C9.81666 24.2634 10.0333 23.5967 9.83246 22.9787C9.63165 22.3607 9.06455 21.9487 7.93035 21.1246L6.13424 19.8197C2.03066 16.8382 -0.0211301 15.3475 0.427898 13.9656C0.876926 12.5836 3.41308 12.5836 8.48538 12.5836H10.7055C12.1074 12.5836 12.8084 12.5836 13.3341 12.2016C13.8599 11.8197 14.0765 11.153 14.5097 9.81966L15.1958 7.70821Z"
      fill={fill}
    />
  </svg>
);

export default Star;
